
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-toy-generator",
      function () {
        return require("private-next-pages/ai-toy-generator/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-toy-generator"])
      });
    }
  